/** What the visitor has typed so far, mirrored into the preview card. */
export interface SignupPreview {
  organizationName: string
  organizationSlug: string
  firstName: string
  lastName: string
  email: string
}

export const EMPTY_SIGNUP_PREVIEW: SignupPreview = {
  organizationName: '',
  organizationSlug: '',
  firstName: '',
  lastName: '',
  email: '',
}
